import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   allLocation: []
};

export const CommonDropdownSlice = createSlice({
   name: "commomDropdown",
   initialState: initialState,
   reducers: {
      setAllLocation: (state, action) => {
         state.allLocation = action.payload;
      }
   },
});
